<script>
// Services
import AIGeneratorService from "@/services/AIGeneratorService"
import UsersDataService from "@/services/UsersDataService"

// Helpers
import Storage from "@/helpers/storage"
import UserUtils from '@/helpers/users'
import DateUtils from '@/helpers/date';
import { getRole } from '@/helpers/role'
import {authComputed} from "@/state/helpers";


// Libs
import isEmpty from "is-empty";


export default {
  name: "ThreadAiView",
  props: {
    threadArg: {
      type: Object,
      default: () => {}
    }
  },

  methods: {
    ...UserUtils,
    ...DateUtils,

    initThread() {
      this.isLoading = true;
      this.isThreadInit = true;
      const params = {
        thread: this.threadArg,
      };

      AIGeneratorService.showThread(params)
          .then(async (response) => {
            this.thread = {...this.threadArg};
            const { user, sender, messages } = response.data;
            this.user = user;
            this.sender = sender;
            this.loadMedia();
            this.messages = messages;
            if (this.user.country !== this.sender.country) {
              this.countriesUnavailable = true;
            }
            this.user.lifeStyle = [];
            this.user.interests = [];
            this.sender.lifeStyle = [];
            this.sender.interests = [];
            this.loadDescription(this.user.userId, "user");
            this.loadDescription(this.sender.userId, "sender");

            this.user.age = this.getAge(user.birth);
            this.sender.age = this.getAge(sender.birth);

            if (new Date().getHours() >= 8 && new Date().getHours() < 22) {
              this.serviceAvailable = true;
            }
            else {
              this.$toast.error("Service Closed !");
            }

            this.loadMessageMedia();
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(error.response.data.message || error.message);
          })
          .finally(() => {
            this.isLoading = false;
          });
      },

    loadMessageMedia() {
      this.messages.forEach(message => {
        if (message.typeMessage === 1) {
          Storage.getMessageMediaUrl(this.thread.chatRoomId, message.attachmentId)
              .then(mediaUrl => {
                const elt = document.getElementById('msg-audio-' + message.messageId);
                if (elt) {
                  elt.setAttribute('src', mediaUrl);
                  elt.load();
                }
              });
        }
        else if (message.typeMessage === 2) {
          let videoFile = message.attachmentId.replace(".jpg", ".mp4");
          videoFile = videoFile.replace("th_", "");
          Storage.getMessageMediaUrl(this.thread.chatRoomId, videoFile)
              .then(mediaUrl => {
                const elt = document.getElementById('msg-video-' + message.messageId);
                if (elt) {
                  elt.setAttribute('src', mediaUrl);
                }
              });
        }
        else if (message.typeMessage === 3) {
          Storage.getMessageMediaUrl(this.thread.chatRoomId, message.attachmentId)
              .then(mediaUrl => {
                const elt = document.getElementById('msg-photo-' + message.messageId);
                if (elt) {
                  elt.setAttribute('src', mediaUrl);
                }
              });
        }
      });
    },

    loadMedia() {
      if (this.user.photo && this.user.photo.length > 0)
        Storage.getUserMedia(this.user.userId, this.user.photo, 'user-'+this.user.userId+'-img');

      if (this.sender.photo && this.sender.photo.length > 0)
        Storage.getUserMedia(this.sender.userId, this.sender.photo, 'sender-'+this.sender.userId+'-img');

      UsersDataService.getMedia(this.user.userId)
          .then(response => {
            const media = response.data;
            const l = media.length;
            if (l > 0) {
              media.forEach(m => {
                m.src = '';
                m.title = m.rankMedia + "/" +l;
                this._loadMedia(m, "user");
              });
            }
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("global_error"));
          });

      UsersDataService.getMedia(this.sender.userId)
          .then(response => {
            const media = response.data;
            const l = media.length;
            if (l > 0) {
              media.forEach(m => {
                m.src = '';
                m.title = m.rankMedia + "/" +l;
                this._loadMedia(m, "sender");
              });
            }
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("global_error"));
          });
    },

    _loadMedia(media, type) {
      let mid, thumbId;
      if (media.typeMedia === 0) {
        if (media.isValid) {
          mid = media.mediaId;
          thumbId = media.thumbFileName;
        }
        else {
          mid = media.mediaId + ".origin";
          thumbId = media.thumbFileName + ".origin";
        }
      }
      else {
        mid = media.mediaId;
        thumbId = media.thumbFileName;
      }

      Storage.getUserMediaUrl(media.userId, mid).then((imageUrl) => {
        media.src = imageUrl;
      });

      Storage.getUserMediaUrl(media.userId, thumbId).then((imageUrl) => {
        media.srcThumb = imageUrl;
        if (type === "user") {
          this.userMedia.push(media);
        }
        else {
          this.senderMedia.push(media);
        }
      })
    },

    showMedia(mediaId, type) {
      let activeMediaIndex;
      let arrMedia;
      if (type === "user") {
        activeMediaIndex = this.userMedia.findIndex(x => x.mediaId === mediaId);
        arrMedia = this.userMedia;
      }
      else {
        activeMediaIndex = this.senderMedia.findIndex(x => x.mediaId === mediaId);
        arrMedia = this.senderMedia;
      }
      this.$emit("SHOW_MEDIA", arrMedia, activeMediaIndex);
    },

    loadDescription(userId, type) {
      UsersDataService.getDescription(userId)
          .then(response => {
            this._createLifeStyle(response.data.lifestyle, response.data.lifestyleSelected, type);
            this._createInterests(response.data.interestsSelected, type);
          })
          .catch(error => {
            window.console.error("UsersDataService.getDescription ERROR", error);
          });
    },

    _createLifeStyle(lifeStyle, lifeStyleSelected, type) {
      const _lifeStyle = [];
      lifeStyle.forEach(lifeStyleCategory => {
        if (lifeStyleCategory.selected !== null) {
          _lifeStyle.push({
            id: lifeStyleCategory.id,
            value: lifeStyleCategory.selected
          });
        }
      });

      if (type === "user") {
        this.userLifeStyle.push(..._lifeStyle);
      }
      else {
        this.senderLifeStyle.push(..._lifeStyle);
      }
    },

    _createInterests(interests, type) {
      if (type === 'user') {
        this.userInterests = Array.from(interests);
      }
      else {
        this.senderInterests = Array.from(interests);
      }
    },

    validateMessage(message) {
      if (!this.serviceAvailable) {
        this.$toast.error("Service is Closed");
        return;
      }


      this.isUpdating = true;
      const params = {
        threadId: this.thread.threadId,
        messageId: message.messageId,
        chatRoomId: this.thread.chatRoomId,
        offsetUTC: this.user.offsetUTC,
        content: null,
        adminId: this.getUser.uid,
        userId: this.user.userId,
        opOffsetUTC: (new Date().getTimezoneOffset() * 60 * -1)
      };

      AIGeneratorService.validateMessage(params)
          .then((result) => {
            message.status = "W"
            message.sendedAt = result.data.sendedAt;
            message.similarity = false;
            this.thread.status = 'R';
            this.thread.lastReplyAt = result.data.lastReplyAt;
            this.newMessage = {};
            this.newContent = '';
            this.updateThreadStatus();
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(error.response.data.message || error.message);
          })
          .finally(() => {
            this.isUpdating = false;
          });
    },

    editMessage(message) {
      this.newMessage = message;
      this.newContent = '' + `${message.content}`;
    },

    cancelnewMessage() {
      this.newMessage = { };
      this.newContent = "";
    },

    generateMessageTerminate() {
      if (!this.serviceAvailable) {
        this.$toast.error("Service is Closed");
        return;
      }

      this.isUpdating = true;
      const params = {
        thread: this.thread,
        sender: this.sender,
        user: this.user,
        adminId: this.getUser.uid,
      };

      AIGeneratorService.generateMessageTerminate(params)
          .then((result) => {
            if (!isEmpty(result.data.error)) {
              this.$toast.error(result.data.error);
            }
            else {
              this.messages.push(result.data.message);
              this.newMessage = {};
              this.newContent = '';
              this.thread.status = 'T';
              this.thread.aiThreadId = result.data.aiThreadId;
              this.updateThreadStatus();
            }
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(error.response.data.message || error.message);
          })
          .finally(() => {
            this.isUpdating = false;
          });
    },

    generateMessage() {
      if (!this.serviceAvailable) {
        this.$toast.error("Service is Closed");
        return;
      }

      this.isUpdating = true;
      const params = {
        thread: this.thread,
        sender: this.sender,
        user: this.user,
        adminId: this.getUser.uid,
      };

      AIGeneratorService.generateMessage(params)
          .then((result) => {
            if (!isEmpty(result.data.error)) {
              this.$toast.error(result.data.error);
            }
            else {
              this.messages.push(result.data.message);
              this.newMessage = {};
              this.newContent = '';
              this.thread.status = 'T';
              this.thread.aiThreadId = result.data.aiThreadId;
              this.updateThreadStatus();
            }
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(error.response.data.message || error.message);
          })
          .finally(() => {
            this.isUpdating = false;
          });
    },

    addManualMessage() {
      if (!this.serviceAvailable) {
        this.$toast.error("Service is Closed");
        return;
      }

      this.isUpdating = true;
      const params = {
        thread: this.thread,
        sender: this.sender,
        user: this.user,
        message: this.newContent,
        adminId: this.getUser.uid,
      };

      AIGeneratorService.addMessage(params)
          .then((result) => {
            if (!isEmpty(result.data.error)) {
              this.$toast.error(result.data.error);
            }
            else {
              this.messages.push(result.data.message);
              this.newMessage = {};
              this.newContent = '';
              this.thread.status = 'T';
              this.thread.aiThreadId = result.data.aiThreadId;
              this.updateThreadStatus();
            }
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(error.response.data.message || error.message);
          })
          .finally(() => {
            this.isUpdating = false;
          });
    },

    updateAndValidMessage() {
      if (!this.serviceAvailable) {
        this.$toast.error("Service is Closed");
        return;
      }

      if (isEmpty(this.newMessage.messageId)) {
        this.addManualMessage();
        return;
      }

      this.isUpdating = true;
      const params = {
        threadId: this.thread.threadId,
        messageId: this.newMessage.messageId,
        chatRoomId: this.thread.chatRoomId,
        content: this.newContent,
        offsetUTC: this.user.offsetUTC,
        adminId: this.getUser.uid,
        userId: this.user.userId,
        opOffsetUTC: (new Date().getTimezoneOffset() * 60 * -1)
      };

      AIGeneratorService.validateMessage(params)
          .then((result) => {
            const message = this.messages.find(elt => elt.messageId === this.newMessage.messageId);
            if (!isEmpty(message)) {
              message.status = "W";
              message.content = this.newContent;
              message.sendedAt = result.data.sendedAt;
              message.similarity = false;
            }

            this.thread.status = 'R';
            this.thread.lastReplyAt = result.data.lastReplyAt;
            this.updateThreadStatus();

            this.newMessage = {};
            this.newContent = '';
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(error.response.data.message || error.message);
          })
          .finally(() => {
            this.isUpdating = false;
          });
    },

    closeThreadUser() {
      if (this.thread.userStatus === 'D' || this.isUpdating) {
        return;
      }

      this.isUpdating = true;
      const params = {
        userId: this.thread.userId,
      };
      AIGeneratorService.disableUser(params)
          .then(() => {
            this.thread.status = 'D';
            this.thread.userStatus = 'D';
            this.updateAllThreadStatus();
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(error.response.data.message || error.message);
          })
          .finally(() => {
            this.isUpdating = false;
          });
    },

    closeThread() {
      if (this.thread.status === 'D' || this.isUpdating) {
        return;
      }

      this.isUpdating = true;
      const params = {
        threadId: this.thread.threadId,
        userId: this.thread.userId,
      };
      AIGeneratorService.closeThread(params)
          .then(() => {
            this.thread.status = 'D';
            this.updateThreadStatus();
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(error.response.data.message || error.message);
          })
          .finally(() => {
            this.isUpdating = false;
          });
    },

    deleteMessage(message) {
      this.isUpdating = true;
      const params = {
        threadId: this.thread.threadId,
        chatRoomId: this.thread.chatRoomId,
        messageId: message.messageId,
        adminId: this.getUser.uid,
      };

      AIGeneratorService.deleteMessage(params)
          .then(() => {
            message.status = "D";
            this.thread.status = 'W';
            this.updateThreadStatus(message);
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(error.response.data.message || error.message);
          })
          .finally(() => {
            this.isUpdating = false;
          });
    },

    updateThreadStatus() {
      this.$emit("UPDATE_THREAD_STATUS", this.thread);
    },

    updateAllThreadStatus() {
      this.$emit("UPDATE_THREAD_STATUS", {
        all: true,
        userId: this.user.userId
      });
    },

    _isEmpty(val) {
      return isEmpty(val);
    },
  },

  watch: {
    threadArg: {
      handler: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          if (newVal !== null ) {
            this.initThread();
          }
        }
      },
      immediate: true
    },
  },

  computed: {
    ...authComputed,

    getUserRole() {
      return getRole(this.getRole);
    }
  },

  data() {
    return {
      countriesUnavailable: false,
      isUpdating: false,
      isLoading: false,
      isThreadInit: false,
      messages:[],
      user: { },
      userLifeStyle: [],
      userInterests: [],
      userMedia: [],
      senderLifeStyle: [],
      senderInterests: [],
      senderMedia: [],
      sender: { },
      newMessage: {
        content: ''
      },
      newContent: '',
      thread: {
        threadId: null,
      },
      serviceAvailable: false,
    }
  }
}
</script>

<template>
  <div v-if="!_isEmpty(thread.threadId)" :id="`user-${thread.threadId}`" class="position-relative">
    <div class="row">
      <div class="col-3">
        <b-card>
          <div v-if="!_isEmpty(user)">
            <div class="avatar-md">
              <img
                  :id="`user-${user.userId}-img`"
                  :src="require('@/assets/images/users/default-user.png')"
                  class="d-flex rounded-circle avatar-md" />
            </div>
            <h5 class="font-size-14 mb-0">
            <span
                :class="{
                'text-primary': user.sex === 1,
                'text-danger': user.sex === 2,
                'text-dark': user.sex === 0,
              }"
            >
              {{ user.name || '-' }}
            </span> {{ getAge(user.birth) }}<br><small>{{ user.locality }}, {{ user.country }}</small></h5>
            <small>#{{ user.userId }}</small><br>
            <b-button v-show="thread.userStatus !== 'D'" class="mt-2" variant="warning" @click="closeThreadUser()">
              Terminate User
            </b-button>
            <hr>
            <h6 class="text-primary">Description</h6>
            <p v-show="!_isEmpty(user.description)" class="text-muted font-size-12 mb-2">{{ user.description }}</p>
            <p v-show="_isEmpty(user.description)" class="text-muted font-size-12 mb-2">no description</p>
            <h6 class="text-primary">LifeStyle</h6>
            <div v-show="!_isEmpty(userLifeStyle)" class="mb-2">
              <p v-for="ls in userLifeStyle" :key="ls.id" class="text-muted font-size-11 mb-1">
                <small class="text-black">{{ $t(`lifestyle.category_${ls.id}`) }}</small>
                <br>{{ $t(`lifestyle.value_${ls.value}`) }}
              </p>
            </div>
            <p v-show="_isEmpty(userLifeStyle)" class="text-muted font-size-12">no lifeStyle</p>
            <h6 class="text-primary">Interests</h6>
            <div v-show="!_isEmpty(userInterests)">
              <span class="badge bg-light text-dark me-2 mb-2"
                    v-for="interest in userInterests"
                    :key="interest.text">#{{ $t(`interests.value_${interest.text}`) }}</span>
              </div>
           </div>
          <p v-show="_isEmpty(userInterests)" class="text-muted font-size-12">no interests</p>

          <h6 class="text-primary">Media</h6>
          <div class="galleryMedia mb-2">
            <div class="galleryMedia-panel position-relative"
                 v-for="medium in userMedia"
                 :key="medium.mediaId">

              <div class="img" v-show="medium.isValid" :style="{backgroundImage: `url(${medium.srcThumb})`}" @click="showMedia(`${medium.mediaId}`, 'user')"></div>

            </div>
          </div>

        </b-card>
      </div>

      <div class="col-6">
        <div class="card">
          <div class="card-body">
            <small>chatRoom #{{ thread.chatRoomId }}</small>
            <hr>
            <div
                v-for="message in messages"
                :key="message.messageId"
                style="width:80%;"
                class="rounded-4 mb-3"
                :class="{
              'float-end msg-sender': `${message.fromId}`=== `${sender.userId}`,
              'float-start msg-user': `${message.fromId}` === `${user.userId}`
            }">
              <div class="m-0">
                <span v-show="!_isEmpty(message.adminUser)" class="badge bg-primary text-white me-2">{{ getInitials(message.adminUser) }} </span>
                <small>{{ formatDateString(message.createdAt, 'DD MMM YYYY HH:mm') }}</small>
                <span v-show="message.modified === 1" class="badge bg-white text-pink ms-2"> UPDATED </span>
                <span v-show="message.tokenInput > 0" class="badge bg-dark text-white ms-2 me-2">tokens {{ message.tokenInput }} IN / {{ message.tokenOutput }} OUT</span>
                <br>
                <!-- text -->
                <div v-show="message.typeMessage === 0">
                  <span v-show="message.iceBreaker === 1" class="badge bg-pink text-white ms-2 me-2">Ice-Breaker</span>
                  {{ message.content }}
                  <div class="m-1 mb-1 bg-warning" v-show="(!_isEmpty(message.similarity) && message.similarity === true || message.status === 'E')">
                    SIMILARITY DETECTED !
                  </div>
                  <div class="mt-1" v-if="message.status !== 'S'">
                    <span
                        class="badge mt-2"
                        :class="{
                      'bg-success text-light': `${message.status}` === 'W',
                      'bg-danger text-light': `${message.status}` === 'E',
                      'bg-warning text-dark': `${message.status}` === 'T',
                      'bg-pink text-light': `${message.status}` === 'D',
                    }"
                    >{{ $t(`ai_generator.status_msg_${message.status}`) }}</span>
                    <span class="d-inline-block ms-2" v-show="!_isEmpty(message.sendedAt) && message.status === 'W'"><small><b>{{ formatDateString(message.sendedAt, 'DD MMM YYYY HH:mm') }}</b></small></span>
                  </div>
                </div>
                <!-- audio -->
                <div v-show="message.typeMessage === 1">
                  <audio :id="'msg-audio-' + message.messageId" controls>
                  </audio>
                </div>
                <!-- video -->
                <div v-show="message.typeMessage === 2">
                  <video :id="'msg-video-' + message.messageId" alt="" style="max-width: 100%" controls />
                </div>
                <!-- photo -->
                <div v-show="message.typeMessage === 3">
                  <img :id="'msg-photo-' + message.messageId" alt="" style="max-width: 100%" />
                </div>
              </div>

              <div class="mt-1" v-show="!isUpdating && ['W','T','E'].includes(message.status)">
                <b-button v-show="!isUpdating && message.status === 'T'" class="rounded-circle ms-2" variant="success" @click="validateMessage(message)">
                  <b-icon icon="check" scale="1"></b-icon>
                </b-button>
                <b-button v-show="!isUpdating && (message.status === 'T' || message.status === 'W' || message.status === 'E')" class="rounded-2 ms-2 me-2 bg-white" variant="outline-danger" @click="deleteMessage(message)">
                  <b-icon icon="x" scale="1"></b-icon> {{ $t("delete") }}
                </b-button>
                <b-button v-show="!isUpdating && (message.status === 'T' || message.status === 'E')" class="rounded-circle ms-2" variant="primary" @click="editMessage(message)">
                  <b-icon icon="pencil-fill" scale="1"></b-icon>
                </b-button>
              </div>
              <span style="clear:both;"></span>
              <p v-if="!_isEmpty(message.instructions) " class="bg-light p-2">
                <small><b>Instructions</b></small><br>
                {{ message.instructions }}
              </p>
            </div>

            <div v-show="['W','T'].includes(thread.status) && thread.userStatus !== 'D'" class="float-lg-end">
              <b-button v-show="!isUpdating" class="ms-2" variant="primary" @click="generateMessage()">
                Generate message
              </b-button>
            </div>
            <div v-show="['W','T'].includes(thread.status) && thread.userStatus !== 'D'" class="float-lg-start">
              <b-button v-show="!isUpdating" class="me-2" variant="outline-primary" @click="generateMessageTerminate()">
                Generate Bye-Bye
              </b-button>
            </div>
          </div>



        </div>

      </div>

      <div class="col-3">
        <b-card>
          <div v-if="!_isEmpty(sender)">
            <div class="avatar-md">
              <img
                  :id="`sender-${sender.userId}-img`"
                  :src="require('@/assets/images/users/default-user.png')"
                  class="d-flex rounded-circle avatar-md" />
            </div>
            <h5 class="font-size-14 mb-0">
            <span
                :class="{
                'text-primary': sender.sex === 1,
                'text-danger': sender.sex === 2,
                'text-dark': sender.sex === 0,
              }"
            >
              {{ sender.name || '-' }}
            </span> {{ getAge(sender.birth) }}<br><small>{{ sender.locality }}, {{ sender.country }}</small></h5>
            <small>#{{ sender.userId }}</small>
          </div>
          <hr>
          <h6 class="text-primary">Description</h6>
          <p v-show="!_isEmpty(sender.description)" class="text-muted font-size-12 mb-2">{{ sender.description }}</p>
          <p v-show="_isEmpty(sender.description)" class="text-muted font-size-12 mb-2">no description</p>
          <h6 class="text-primary">LifeStyle</h6>
          <div v-show="!_isEmpty(senderLifeStyle)" class="mb-2">
            <p v-for="ls in senderLifeStyle" :key="ls.id" class="text-muted font-size-11 mb-1">
              <small class="text-black">{{ $t(`lifestyle.category_${ls.id}`) }}</small>
              <br>{{ $t(`lifestyle.value_${ls.value}`) }}
            </p>
          </div>
          <p v-show="_isEmpty(senderLifeStyle)" class="text-muted font-size-12">no lifeStyle</p>
          <h6 class="text-primary">Interests</h6>
          <div v-show="!_isEmpty(senderInterests)">
              <span class="badge bg-light text-dark me-2 mb-2"
                    v-for="interest in senderInterests"
                    :key="interest.text">#{{ $t(`interests.value_${interest.text}`) }}</span>
          </div>
           <p v-show="_isEmpty(senderInterests)" class="text-muted font-size-12">no interests</p>
          <h6 class="text-primary">Media</h6>
          <div class="galleryMedia mb-2">
            <div class="galleryMedia-panel"
                 v-for="medium in senderMedia"
                 :key="medium.mediaId">

              <div class="img" v-show="medium.isValid" :style="{backgroundImage: `url(${medium.srcThumb})`}" @click="showMedia(`${medium.mediaId}`, 'sender')"></div>

            </div>
          </div>
        </b-card>
      </div>

    </div>

    <div class="row" v-show="countriesUnavailable">
      <div class="bg-danger text-light p-2 col-12">
        Countries are not valid !
      </div>
    </div>

    <div class="row" style="clear:both;">
      <div class="col-3">
        <b-button v-show="thread.status !== 'D'" class="mt-2" variant="danger" @click="closeThread()">
          Terminate Chat
        </b-button>
      </div>
      <div class="col-9">
        <b-textarea
            v-show="['W','T'].includes(thread.status) && thread.userStatus !== 'D'"
            id="messageContent"
            v-model="newContent"
            rows="3"
            class="bg-white"
            placeholder="Type message…"
        >
        </b-textarea>
        <br>
        <b-button v-show="!_isEmpty(newContent) && !isUpdating" class="ms-2" variant="primary" @click="updateAndValidMessage()">
          Valid Message
        </b-button>
        <b-button v-show="!_isEmpty(newContent) && !isUpdating" class="ms-2" variant="danger" @click="cancelnewMessage()">
          Cancel updating
        </b-button>
      </div>
    </div>

    <div class="updateLoading" v-show="isUpdating || isLoading">
      <vue-ellipse-progress
          v-show="isUpdating"
          :loading="true"
          :angle="-90"
          color="#50a5f1"
          emptyColor="#999"
          emptyColorFill="#fff"
          :size="100"
          :thickness="3"
          :emptyThickness="2"
          lineMode="out 2"
          animation="bounce 700 400"
          fontColor="#666"
          :half="false"
          fontSize="1rem">
      </vue-ellipse-progress>
    </div>
  </div>
</template>

<style>
.msg-sender {
  background-color: #9be2ef;
  padding:10px;
}

.msg-user {
  background-color: #f2f2f2;
  padding:10px;
}

.galleryMedia {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 100px));
  grid-gap: 0.5rem;
  margin: 0.5rem auto;
  padding: 0;
}
.galleryMedia-panel {
  cursor: pointer;
  box-shadow: #ccc 1px 0 10px;
}
.galleryMedia-panel .img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  border-radius: 0.15rem;
}

</style>
